import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './library.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var Library = /** @class */ (function (_super) {
    tslib_1.__extends(Library, _super);
    function Library(element) {
        return _super.call(this, element) || this;
    }
    Library.prototype.init = function () {
        this.containerLibraryTypes = this.element.querySelector('.library__types');
        this.containerLibrarySearch = this.element.querySelector('.library__components--search');
        this.containerLibrarySearchItems = this.element.querySelector('.library__components--search__items');
        this.containerLibraryComponents = this.element.querySelector('.library__components');
        this.containerLibraryPages = this.element.querySelector('.library__pages');
        this.containerLibraryPagesItems = this.element.querySelector('.library__pages__items');
        this.clickPagesShow = Array.from(this.element.querySelectorAll('.js-show-pages'));
        this.searchBar = this.element.querySelector('.js-search-bar');
        this.jsonComponents = jsonComponents;
        this.jsonPages = jsonPages;
        this.createTable();
        this.createPages();
    };
    Library.prototype.bindEvents = function () {
        var _this = this;
        this.clickPagesShow.map(function (item) { return item.addEventListener('click', function () {
            _this.containerLibraryTypes.classList.add('d-none');
            _this.containerLibraryPages.classList.remove('d-none');
        }); });
        this.searchBar.addEventListener('keyup', function (evt) {
            _this.searchComponents(evt.target.value);
        });
        $('body').on("click", "td.js-folder-click", function (evt) {
            var element = evt.target;
            var attribute = element.getAttribute('data-folder');
            $("tr[data-folder='" + attribute + "']").each(function (index, element) {
                if (element.classList.contains('d-none')) {
                    element.classList.remove('d-none');
                }
                else {
                    element.classList.add('d-none');
                }
            });
        });
    };
    Library.prototype.createPages = function () {
        var _this = this;
        var array = this.jsonPages;
        array.forEach(function (page) {
            var link = page.name;
            link = link.toLowerCase();
            link = link.replace(/ /g, '-');
            link = link + '.html';
            var output = "<div class=\"col-md-6\">\n\t\t\t\t<div class=\"article-combo-item  \">\n\t\t\t\t\t<div class=\"article-combo-item__content \">\n\t\t\t\t\t\t<a href=\"" + link + "\"\n\t\t\t\t\t\t\tclass=\"article-combo-item__title   \">\n\t\t\t\t\t\t\t" + page.name + "\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<div class=\"article-combo-item__link\">\n\t\t\t\t\t\t\t<a href=\"" + link + "\"\n\t\t\t\t\t\t\t\tclass=\"link\">\n\t\t\t\t\t\t\t\t<span class=\"link__text\">\n\t\t\t\t\t\t\t\t\tView page\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>";
            var docFragment = document.createDocumentFragment();
            docFragment.appendChild(document.createRange().createContextualFragment(output));
            _this.containerLibraryPagesItems.appendChild(docFragment);
        });
    };
    Library.prototype.createTable = function () {
        // components
        var arrayComponents = this.jsonComponents;
        // folders
        var arrayFoldersNew = [];
        arrayComponents.forEach(function (component) {
            var templateFolder = component.templateFolder;
            if (templateFolder) {
                templateFolder.forEach(function (folder) {
                    arrayFoldersNew.push(folder);
                });
            }
        });
        var uniqueFolders = _.uniq(arrayFoldersNew);
        // folders
        var arrayDisplayViewsNew = [];
        arrayComponents.forEach(function (component) {
            var displayViews = component.displayViews;
            if (displayViews) {
                displayViews.forEach(function (displayView) {
                    arrayDisplayViewsNew.push(displayView);
                });
            }
        });
        var uniqueDisplayViews = _.uniq(arrayDisplayViewsNew);
        // filter
        var array = [];
        uniqueFolders.forEach(function (folder) {
            var objectFolder = {
                name: folder,
                components: []
            };
            uniqueDisplayViews.forEach(function (view) {
                arrayComponents.forEach(function (component) {
                    var templateFolder = component.templateFolder;
                    var displayViews = component.displayViews;
                    if (templateFolder) {
                        if (displayViews) {
                            if (displayViews.includes(view) && templateFolder.includes(folder)) {
                                var object = {
                                    view: view,
                                    component: component
                                };
                                objectFolder.components.push(object);
                            }
                        }
                    }
                });
            });
            array.push(objectFolder);
        });
        var output = "<table style=\"display: table;\" class=\"table table--blue table-responsive table-striped\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Folder</th>\n\t\t\t\t\t<th>Display View</th>\n\t\t\t\t\t<th>Component</th>\n\t\t\t\t\t<th>Dev</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
        array.forEach(function (folder) {
            output += "<tr>\n\t\t\t\t<td colspan=\"5\" class=\"text-white title title--entrance gradient-orange js-folder-click\" style=\"cursor: pointer;\" data-folder=\"" + folder.name.toLowerCase() + "\">" + folder.name + "</td>\n\t\t\t</tr>";
            var components = folder.components;
            components.forEach(function (component) {
                var link = component.component.name;
                link = link.toLowerCase();
                link = link.replace(/ /g, '-');
                link = link + '.html';
                output += "<tr class=\"d-none\" data-folder=\"" + folder.name.toLowerCase() + "\">\n\t\t\t\t\t<td></td>\n\t\t\t\t\t<td>" + component.view + "</td>\n\t\t\t\t\t<td><a href=\"" + link + "\">" + component.component.name + "</a></td>\n\t\t\t\t\t<td>" + component.component.dev + "</td>\n\t\t\t\t</tr>";
            });
        });
        output += "</tbody></table>";
        var docFragment = document.createDocumentFragment();
        docFragment.appendChild(document.createRange().createContextualFragment(output));
        this.containerLibraryComponents.appendChild(docFragment);
    };
    Library.prototype.searchComponents = function (term) {
        var _this = this;
        if (term === void 0) { term = ''; }
        this.containerLibrarySearchItems.innerHTML = '';
        if (term) {
            this.containerLibrarySearch.classList.remove('d-none');
            var array = this.jsonComponents;
            array.forEach(function (component) {
                var lowercaseTerm = term.toLowerCase();
                var lowercaseName = component.name.toLowerCase();
                var lowercaseTemplateFolders = [];
                var lowercaseDisplayViews = [];
                if (component.templateFolder && component.displayViews) {
                    lowercaseTemplateFolders = component.templateFolder.map(function (v) { return v.toLowerCase(); });
                    lowercaseDisplayViews = component.displayViews.map(function (v) { return v.toLowerCase(); });
                }
                if (lowercaseName.includes(lowercaseTerm) || lowercaseTemplateFolders.includes(lowercaseTerm) || lowercaseDisplayViews.includes(lowercaseTerm)) {
                    var link = component.name;
                    link = link.toLowerCase();
                    link = link.replace(/ /g, '-');
                    link = link + '.html';
                    var output = "<div class=\"col-md-6\">\n\t\t\t\t\t\t<div class=\"article-combo-item  \">\n\t\t\t\t\t\t\t<div class=\"article-combo-item__content \">\n\t\t\t\t\t\t\t\t<a href=\"" + link + "\"\n\t\t\t\t\t\t\t\t\tclass=\"article-combo-item__title   \">\n\t\t\t\t\t\t\t\t\t" + component.name + "\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<div class=\"article-combo-item__link\">\n\t\t\t\t\t\t\t\t\t<a href=\"" + link + "\"\n\t\t\t\t\t\t\t\t\t\tclass=\"link\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"link__text\">\n\t\t\t\t\t\t\t\t\t\t\tView component\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
                    var docFragment = document.createDocumentFragment();
                    docFragment.appendChild(document.createRange().createContextualFragment(output));
                    _this.containerLibrarySearchItems.appendChild(docFragment);
                }
            });
        }
    };
    return Library;
}(Base));
export { Library };



//////////////////
// WEBPACK FOOTER
// ./components/library/library.component.ts
// module id = 589
// module chunks = 0